export const ADMIN_UID = 'ae0W0HMej0RZuSephCrOrwCap3f2'; // <-- tu UID admin
